<template>
	<i class="w-8 h-8 flex items-center justify-center">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="currentColor"
		>
			<path
				d="M8.80013 27.9996C7.80013 27.9996 6.81124 27.7552 5.83346 27.2663C4.85569 26.7774 4.0668 26.133 3.4668 25.333C4.04457 25.333 4.63346 25.1052 5.23346 24.6496C5.83346 24.1941 6.13346 23.533 6.13346 22.6663C6.13346 21.5552 6.52235 20.6107 7.30013 19.833C8.07791 19.0552 9.02235 18.6663 10.1335 18.6663C11.2446 18.6663 12.189 19.0552 12.9668 19.833C13.7446 20.6107 14.1335 21.5552 14.1335 22.6663C14.1335 24.133 13.6112 25.3885 12.5668 26.433C11.5224 27.4774 10.2668 27.9996 8.80013 27.9996ZM16.4668 19.9996L12.8001 16.333L24.7335 4.39963C24.9779 4.15518 25.2835 4.0274 25.6501 4.01629C26.0168 4.00518 26.3335 4.13296 26.6001 4.39963L28.4001 6.19963C28.6668 6.46629 28.8001 6.7774 28.8001 7.13296C28.8001 7.48851 28.6668 7.79963 28.4001 8.06629L16.4668 19.9996Z"
			/>
		</svg>
	</i>
</template>
